// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1869":"3fa286df340b873e2a8f","3198":"6ef92522494848c51f8e"}[chunkId] + ".css";
};